module.exports = __webpack_public_path__ + "static/img/game-head-cjxxl.d253baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-head-cjxxl.png
// module id = NIpT
// module chunks = 1